<script>
  import Button from './button.svelte';

  export let align;
  export let backgroundImage;
  export let header;
  export let subtext;
  export let link;
  export let buttonText;

  // Reactive statement to determine position
  $: positionStyle = align === 'right' ? 'right: 34px; text-align: right;' : 'left: 34px; text-align: left;';
</script>

<div class="card" style="background-image: url('../images/backgrounds/{backgroundImage}');">
  <div class="content" style="{positionStyle}">
    <h1>{@html header}</h1>
    <p>{@html subtext}</p>
    <Button
      text={buttonText}
      link={link}
      />
  </div>
</div>


<style>
  .card {
    font-family: 'Oswald', sans-serif;
    position: relative;
    background-size: cover;
    background-position: center;
    width: 100%;
    aspect-ratio: 2 / 1;
    display: flex;
    align-items: flex-end;
    padding: 20px;
  }

  .content {
    position: absolute;
    bottom: 34px;
    color: white; /* Adjust text color as needed */
  }

  .content h1 {
    font-size: 2.5rem; /* Adjust title size as needed */
    margin: 0 0 10px 0;
  }

  .content p {
    font-size: 1.34rem; /* Adjust subtitle size as needed */
    margin: 0 0 20px 0;
    font-family: "Arial", Sans-serif;
  }

  /* Media query for devices with a width of up to 768 pixels */
  @media (max-width: 768px) {
    .content h1 {
      font-size: 1.5rem;
    }

    .content p {
      font-size: 0.8rem;
    }

    .content {
    position: absolute;
    bottom: 17px;
    color: white; /* Adjust text color as needed */
    }
    .card {
    aspect-ratio: 1.17 / 1;
    }
  }
</style>